import React from 'react';
import { Camera, Instagram, Twitter, Youtube } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => (
  <footer className="border-t border-black/5 bg-[#fbf9f2] mt-24">
    <div className="max-w-7xl mx-auto px-5 lg:px-8 py-14 grid md:grid-cols-4 gap-10">
      <div className="md:col-span-2">
        <div className="flex items-center gap-2 mb-3">
          <div className="w-9 h-9 rounded-xl bg-emerald-700 text-white grid place-items-center"><Camera className="w-5 h-5" /></div>
          <span className="font-display text-xl font-bold text-emerald-950">CalorieSnap</span>
        </div>
        <p className="text-emerald-950/70 max-w-sm">The smart and easy way to analyse your calorie intake. Snap a meal, get instant macros, build habits that stick.</p>
        <div className="flex gap-3 mt-5">
          {[Instagram, Twitter, Youtube].map((Icon, i) => (
            <a key={i} href="#" className="w-9 h-9 rounded-full border border-emerald-950/10 grid place-items-center hover:bg-emerald-700 hover:text-white hover:border-emerald-700 transition-colors"><Icon className="w-4 h-4" /></a>
          ))}
        </div>
      </div>
      <div>
        <h4 className="font-semibold text-emerald-950 mb-3">Product</h4>
        <ul className="space-y-2 text-emerald-950/70 text-sm">
          <li><Link to="/pricing">Pricing</Link></li>
          <li><a href="/#features">Features</a></li>
          <li><a href="/#how">How it works</a></li>
          <li><a href="/#faq">FAQ</a></li>
        </ul>
      </div>
      <div>
        <h4 className="font-semibold text-emerald-950 mb-3">Company</h4>
        <ul className="space-y-2 text-emerald-950/70 text-sm">
          <li><a href="#">About</a></li>
          <li><a href="#">Blog</a></li>
          <li><a href="#">Privacy</a></li>
          <li><a href="#">Terms</a></li>
        </ul>
      </div>
    </div>
    <div className="border-t border-black/5"><div className="max-w-7xl mx-auto px-5 lg:px-8 py-5 flex flex-col md:flex-row justify-between items-center text-sm text-emerald-950/60"><p>© {new Date().getFullYear()} CalorieSnap. All rights reserved.</p><p>Made with care for healthier days.</p></div></div>
  </footer>
);

export default Footer;
